"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Param {
    constructor(key, shortKey, defVal, getterFn, setterFn) {
        this.key = key;
        this.shortKey = shortKey;
        this.defaultValue = defVal;
        this.getterFn = getterFn;
        this.setterFn = setterFn;
    }
}
exports.default = Param;
